// Don't remove comments
export const emptyClientProduct: Record<string, string | number> = {
    ean: '',
    name: '',
    status: '',
    // category: '',
    // subcategory: '',
    // segment: '',
    // brand: '',
    // market: '',
    mrdr: '',
    pe: '',
    recommended_price_min: 0,
    recommended_price_max: 0,
    recommended_price_main: 0,
    products_by_packaging: 0,
    average_weekly_sales: 0,
};

export const emptyClientProductToEdit: Record<string, string | number> = {
    status: '',
    mrdr: '',
    pe: '',
    recommended_price_min: '',
    recommended_price_max: '',
    recommended_price_main: '',
    products_by_packaging: '',
    average_weekly_sales: '',
};
